import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { useEdit, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { MainContainer } from "../../components"
import { Card, CardBody, CardFooter, Button, Input } from "@nextui-org/react"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function EditPasswordClientMaster() {
  const navigate = useNavigate()

  const { selectedClient } = useSelector((state) => state.clientMaster)
  const [errors, setErrors] = useState({})

  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)

  const [formData, setFormData] = useState({
    client_code: selectedClient.client_code,
    client_name: selectedClient.client_name,
    old_client_name: selectedClient.client_name,
    client_group: selectedClient.client_group,
    server_name: selectedClient.server_name,
    client_db: selectedClient.client_db,
    client_db_uid: selectedClient.client_db_uid,
    client_db_password: "",
    client_db_confirm_password: "",
  })

  const onClickPrevPage = () => {
    navigate(linksUrl.clientMaster.read)
  }

  const onSuccessTasks = () => {
    navigate(linksUrl.clientMaster.read)
  }
  const resetValues = () => {}

  const { isPending, mutate: editPasswordClientMaster } = useEdit({
    url: apiRoute.clientMaster.edit.password,
    queryKey: "ClientMaster",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate client_code
    if (formData.client_code.trim() === "") {
      newErrors.client_code = "Client Code is required"
    }

    // Validate client_name
    if (formData.client_name.trim() === "") {
      newErrors.client_name = "Client Name is required"
    }
    // Validate password
    if (formData.client_db_password.trim() === "") {
      newErrors.client_db_password = "Password is required"
    }

    // Validate password
    if (formData.client_db_confirm_password.trim() === "") {
      newErrors.client_db_confirm_password = "Confirm Password is required"
    }

    // Validate password
    if (formData.client_db_password !== formData.client_db_confirm_password) {
      newErrors.client_db_confirm_password =
        "Confirm Password needs to be same same Password"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      // Perform form submission logic here
      
      editPasswordClientMaster({
        data: {
          client_code: formData.client_code,
          client_name: formData.client_name,
          client_db_password: formData.client_db_password,
          client_db_confirm_password: formData.client_db_confirm_password,
        },
      })
    }
  }

  return (
    <div>
      <MainContainer
        pageName="Edit Client Master"
        breadcrumbs={["Client Master", "Edit"]}
        prevPage={{ show: true, onClick: onClickPrevPage }}
      >
        <Card className="max-w-[600px]" shadow="none" classNames="p-0">
          <form onSubmit={handleSubmit}>
            <CardBody className="p-0">
              <div className="flex flex-col gap-4 mx-2">
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input
                    type="text"
                    label="Client Code"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_code}
                    errorMessage={errors?.client_code}
                    name="client_code"
                    value={formData.client_code}
                    onChange={handleChange}
                    isDisabled={true}
                  />
                  <Input
                    type="text"
                    label="Client Name"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_name}
                    errorMessage={errors?.client_name}
                    name="client_name"
                    value={formData.client_name}
                    onChange={handleChange}
                    isDisabled={true}
                  />
                </div>
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input
                    type="text"
                    label="Client Group"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_group}
                    errorMessage={errors?.client_group}
                    name="client_group"
                    value={formData.client_group}
                    onChange={handleChange}
                    isDisabled={true}
                  />
                  <Input
                    type="text"
                    label="Database Server Name"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.server_name}
                    errorMessage={errors?.server_name}
                    name="server_name"
                    value={formData.server_name}
                    onChange={handleChange}
                    isDisabled={true}
                  />
                </div>
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input
                    type="text"
                    label="Client Database"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_db}
                    errorMessage={errors?.client_db}
                    name="client_db"
                    value={formData.client_db}
                    onChange={handleChange}
                    isDisabled={true}
                  />
                  <Input
                    type="text"
                    label="Database User Id"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_db_uid}
                    errorMessage={errors?.client_db_uid}
                    name="client_db_uid"
                    value={formData.client_db_uid}
                    onChange={handleChange}
                    isDisabled={true}
                  />
                </div>
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input
                    label="Password"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_db_password}
                    errorMessage={errors?.client_db_password}
                    name="client_db_password"
                    value={formData.client_db_password}
                    onChange={handleChange}
                    isDisabled={isPending}
                    endContent={
                      <button
                        className="focus:outline-none"
                        type="button"
                        onClick={toggleVisibility}
                      >
                        {isVisible ? (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faEye} />
                        )}
                      </button>
                    }
                    type={isVisible ? "text" : "password"}
                  />
                  <Input
                    label="Confirm Password"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_db_confirm_password}
                    errorMessage={errors?.client_db_confirm_password}
                    name="client_db_confirm_password"
                    value={formData.client_db_confirm_password}
                    onChange={handleChange}
                    isDisabled={isPending}
                    endContent={
                      <button
                        className="focus:outline-none"
                        type="button"
                        onClick={toggleVisibility}
                      >
                        {isVisible ? (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faEye} />
                        )}
                      </button>
                    }
                    type={isVisible ? "text" : "password"}
                  />
                </div>
              </div>
            </CardBody>
            <CardFooter>
              <Button color="primary" type="submit" isLoading={isPending}>
                Edit Client Master
              </Button>
            </CardFooter>
          </form>
        </Card>
      </MainContainer>
    </div>
  )
}

export default EditPasswordClientMaster
